import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import {useStyles} from "./PersonStyle";
import muslimImg from './muslim.png';
import gymImg from './gym.png';
import yarmulkeImg2 from './jewish.png';
import orthodoxImg from './orthodox.png';
import friends from './friends1.png';
import './EditDialogStyle.css'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import {DialogContent} from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import Tooltip from '@material-ui/core/Tooltip';
import "./PersonStyle.css"

export default function PersonComponent({
                                            OpenDialog, person, chosenCategories, hasFilter, acquaintancesCallback,
                                            acquaintancesIds, exercisesAcquaintancesCallback, exercisesAcquaintancesIds,
                                            isInterviewPage, classId, sessionsId, callbackShowToast, callbackShowErrorToast, callbackShowMessageToast = null,
                                            intreviewsHours = ["0", "0"], isReviewer = false, isFirst = 1, editData
                                        }) {

    const classes = useStyles();
    const [isInfoDialogOpen, setIsInfoDialogOpen] = useState(Boolean(OpenDialog));
    const [personAcquaintancesClasses, setPersonAcquaintancesClasses] = useState([]);
    const [showCollisionDialog, setShowCollisionDialog] = useState(false);
    const [swapPerson, setSwapPerson] = React.useState("");
    const [collisionData, setCollisionData] = React.useState([{name: "", id: ""}, {name: "", id: ""}]);

    const isHighlight = () => {
        if (!hasFilter) {
            return false;
        }
        for (let i = 0; i < Object.keys(chosenCategories).length; i++) {
            const category = Object.keys(chosenCategories)[i];
            // if the category value isn't none and also not the same as person value(for this category) the person shouldn't be highlighted
            if (person[category] !== chosenCategories[category] && chosenCategories[category] !== 'none') {
                return false;
            }
        }
        return true;
    };

    const tribeImg = () => {
        let tribeImg;
        if (person.tribe === "דתי לאומי") {
            tribeImg = yarmulkeImg2;
        }
        if (person.tribe === "ערבי") {
            tribeImg = muslimImg;
        }
        if (person.tribe === "חילוני") {
            tribeImg = gymImg;
        }
        if (person.tribe === "חרדי") {
            tribeImg = orthodoxImg;
        }
        return <Tooltip title={person.tribe}>
            <img src={tribeImg} alt="" style={{height: '30px', width: '30px', marginLeft: '2px'}}/>
        </Tooltip>
    };

    const acquaintancesButton = () => {
        if (person.acquaintances.length > 0 || (person.exercisesAcquaintances && person.exercisesAcquaintances.length > 0)) {
            return <Tooltip title="לחץ על מנת לראות מכרים">
                <img src={friends} alt=""
                     style={{height: '30px', width: '30px', marginLeft: '2px', cursor: 'pointer'}}
                     onClick={() => {
                         // The click is on interview reviewer
                         if (exercisesAcquaintancesCallback && person.exercisesAcquaintances) {
                             acquaintancesCallback(person.acquaintances, person.exercisesAcquaintances);
                         } else {
                             acquaintancesCallback(person.acquaintances, []);

                         }
                     }}/>
            </Tooltip>
        } else {
            return <div style={{height: '30px', width: '30px', marginLeft: '2px'}}></div>;
        }
    };

    const handleSwapChange = event => {
        setSwapPerson(event.target.value);
    };

    const handleSwapAction = () => {
        let peopleToEdit;
        if (isReviewer) {
            peopleToEdit = [{
                "person_id": person.id,
                "interviewsClass": editData.desiredClass,
            },
                {
                    "person_id": swapPerson,
                    "interviewsClass": classId
                }];
        } else {
            peopleToEdit = [{
                "person_id": person.id,
                "interviewsClass": editData.desiredClass,
                "isFirst": editData.isFirst,
            },
                {
                    "person_id": swapPerson,
                    "interviewsClass": classId,
                    "isFirst": isFirst
                }];
        }
        submitEdit(peopleToEdit);
    };

    const setPeopleToEdit = () => {
        let peopleToEdit;
        if (isReviewer === true) {
            peopleToEdit = {
                "person_id": person.id,
                "interviewsClass": editData.desiredClass
            };
        } else {
            peopleToEdit = {
                "person_id": person.id,
                "interviewsClass": editData.desiredClass,
                "isFirst": editData.isFirst
            };
        }
        return peopleToEdit;
    };

    const interviewsEdit = async () => {
        let peopleToEdit = setPeopleToEdit();
        const formData = new FormData();
        formData.append('peopleChanges', JSON.stringify(peopleToEdit));

        const getTeamsUrl = process.env.REACT_APP_BACKEND_URL + "/sessions/editValidation/" + sessionsId;
        try {
            const res = await fetch(getTeamsUrl, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                },
                body: formData
            });
            if (res.status === 401) {
                window.location.replace(process.env.REACT_APP_URL)
            }
            const data = await res.json();
            if (data.status === "Not Valid") {
                setShowCollisionDialog(true);
                setSwapPerson(data.person[0].id);
                setCollisionData(data.person);
            } else if (data.status === "Valid") {
                submitEdit([peopleToEdit]);
            } else {
                callbackShowErrorToast("ארעה שגיאה לא צפויה, נסו שנית במועד מאוחר יותר ");
            }
        }
        catch (error) {
            callbackShowErrorToast("ארעה שגיאה לא צפויה, נסו שנית במועד מאוחר יותר ");
        }
    };

    useEffect(() => {
            // starts edit if this is the desired person, handles only interview edit
            if (isInterviewPage && editData && editData.personId === person.id) {
                // Illegal position
                if (isReviewer !== editData.reviewerPosition) {
                    if (editData.reviewerPosition) {
                        callbackShowMessageToast("מקום זה מיועד למעריך ולא למועמד");
                        return;
                    } else {
                        callbackShowMessageToast("מקום זה מיועד למועמד ולא למעריך");
                        return;
                    }
                }
                // Checks that the position is not the current position
                if (editData.desiredClass !== classId || (editData.isFirst !== undefined && editData.isFirst !== isFirst)) {
                    interviewsEdit();
                }
            }
        },
        // eslint-disable-next-line
        [editData]);

    useEffect(() => {
            const oldPersonAcquaintancesClasses = personAcquaintancesClasses;
            if (acquaintancesIds && acquaintancesIds[person.id] !== undefined) {
                // regular acquaintances
                if (acquaintancesIds[person.id]) {
                    setPersonAcquaintancesClasses([...oldPersonAcquaintancesClasses, classes.nameButtonRed])
                } else {
                    setPersonAcquaintancesClasses([...oldPersonAcquaintancesClasses, classes.nameButtonBlue])
                }
                const timer = setTimeout(() => {
                    setPersonAcquaintancesClasses(personAcquaintancesClasses.filter(cssClass => cssClass !== classes.nameButtonRed && cssClass !== classes.nameButtonBlue));
                }, 3000);
                return () => clearTimeout(timer);
                // for the case of change acquaintancesIds before timeout
            } else {
                setPersonAcquaintancesClasses(personAcquaintancesClasses.filter(cssClass => cssClass !== classes.nameButtonRed && cssClass !== classes.nameButtonBlue));
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [acquaintancesIds]);

    const submitEdit = async (peopleToEdit) => {
        const formData = new FormData();
        formData.append('peopleChanges', JSON.stringify(peopleToEdit));
        const getTeamsUrl = process.env.REACT_APP_BACKEND_URL + "/sessions/edit/" + sessionsId;
        try {
            const res = await fetch(getTeamsUrl, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                },
                body: formData
            });
            if (res.status === 401) {
                window.location.replace(process.env.REACT_APP_URL)
            }
            let data = await res.json();

            if (data.status === "Success" || data.status === "No Changes") {
                if (data.status === "Success") {
                    callbackShowToast();
                }
            } else {
                callbackShowErrorToast("ארעה שגיאה לא צפויה, נסו שנית במועד מאוחר יותר ");
            }
        }
        catch(error) {
            callbackShowErrorToast("ארעה שגיאה לא צפויה, נסו שנית במועד מאוחר יותר ");
        }
    };

    return (
        <Card className={isHighlight() ? classes.highlight : classes.personCard} style={{marginTop: '0'}}>
            <CardContent style={{padding: '0px', height: '32px', direction: 'rtl'}}
                         className={person.gender === 'נקבה' ? classes.female : person.gender === 'זכר' ? classes.male : ''}>
                <div style={{display: 'flex'}}>
                    <Button onClick={() => {
                        setIsInfoDialogOpen(true)
                    }} className={personAcquaintancesClasses.join(' ')}
                            style={{height: '32px', borderRadius: '0'}}>
                        <div className="personName">
                            {person.name}
                        </div>
                    </Button>
                    {acquaintancesButton()}
                    {tribeImg()}
                </div>
            </CardContent>
            <Dialog open={isInfoDialogOpen} onClose={() => {
                setIsInfoDialogOpen(false)
            }} maxWidth={false} dir="rtl">
                <DialogTitle className="PersonHeader" disableTypography={true}>
                    <div className="Icon">
                        <EmojiPeopleIcon/>
                    </div>
                    <div className="DialogHeader">
                        {person.name}
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className="PersonAttr">
                        {person.role}
                    </div>
                    <div className="PersonAttr">
                        {person.organization}
                    </div>
                    <div className="PersonAttr">
                        {person.gender}
                    </div>
                    <div className="PersonAttr">
                        {person.tribe}
                    </div>
                    <div className="PersonAttr">
                        {person.sector}
                    </div>
                    <div className="PersonAttr">
                        {person.phone_number}
                    </div>
                    <Button onClick={() => {
                        setIsInfoDialogOpen(false)
                    }} className="closeButton">
                        סגור
                    </Button>
                </DialogContent>
            </Dialog>

            {/*Collision dialog - in case the user wants to edit a person.*/}
            <Dialog open={showCollisionDialog}
                    maxWidth={false} dir="rtl">
                <DialogTitle className="EditCollisionDialogHeader" disableTypography={true}>
                    <div className="Icon">
                        <DirectionsWalkIcon style={{transform: "scale(-1,1)"}}/>
                        <CompareArrowsIcon/>
                        <DirectionsWalkIcon/>
                    </div>
                    <div className="DialogHeader">
                        עריכת{' '}{person.name}
                    </div>
                </DialogTitle>
                <DialogContent className="EditContent">
                    {isReviewer ?
                        (
                            <div>
                                <div className="EditInfo">הכיתה אליה ברצונך לעבור מלאה. אנא בחר מעריך להתחלף איתו:</div>
                                <div>
                                    <FormControl component="fieldset">
                                        <RadioGroup aria-label="gender" name="gender1"
                                                    value={swapPerson}
                                                    onChange={handleSwapChange}
                                                    style={{display: "block"}}>
                                            <FormControlLabel value={collisionData[0].id} control={<Radio/>}
                                                              className="Option"
                                                              label={collisionData[0].name}/>
                                            <FormControlLabel value={collisionData[1].id} control={<Radio/>}
                                                              className="Option"
                                                              label={collisionData[1].name}/>
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className="EditInfo">
                                    המועמד{' '}{collisionData[0].name} נמצא בשעה ובכיתה אליה אתה מעוניין לעבור. האם אתה
                                    מעוניין להחליף איתו?
                                </div>
                            </div>
                        )
                    }

                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => {
                        setShowCollisionDialog(false);
                    }} color="primary" className="CancelButton">
                        בטל
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleSwapAction}
                            className="SubmitButton">
                        החלף
                    </Button>
                </DialogActions>
            </Dialog>
        </Card>
    );
}
